import { render, staticRenderFns } from "./ActionViewIcon.vue?vue&type=template&id=55efd5b7"
import script from "@/components/action-icon/action-view-icon/ActionViewIcon.ts?vue&type=script&lang=ts&external"
export * from "@/components/action-icon/action-view-icon/ActionViewIcon.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/action-icon/action-view-icon/action-view-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports